export const colorPickerDefaults = [
  "#eb4a62",
  "#eb677a",
  "#ed6a45",
  "#f19d70",
  "#f29d4b",
  "#f8cc55",
  "#fffd7e",
  "#d7fc51",
  "#b9eed3",
  "#5fcdca",
  "#6dbde2",
  "#8f36aa",
  "#db4ccc",
  "#ea3ac6",
];
